import { Card } from '../components/Card';

export function About() {
  return (
    <div className="mx-auto max-w-md px-4 pt-4 pb-24 space-y-4">
      <h1 className="font-display text-3xl uppercase tracking-wide">About PunditXI</h1>

      <Card>
        <p className="text-sm text-text-base leading-relaxed">
          PunditXI is a Telegram Mini App for football predictions — focused on the 2026 FIFA World
          Cup but supporting daily fixtures across the world's top leagues year-round.
        </p>
      </Card>

      <Card>
        <h2 className="font-chunky text-base mb-2">How it works</h2>
        <ul className="space-y-2 text-sm text-text-dim list-disc list-inside">
          <li>Predict daily fixtures for free — 1X2, BTTS, exact score.</li>
          <li>Bracket Premium lets you lock the whole tournament: 12 groups, full knockout, champion, Golden Boot.</li>
          <li>Stars items (Boost, Insurance, Streak Protector, Tipster Pack, Re-Lock) add depth.</li>
          <li>Climb private leagues with mates, country leagues for your nation, or the global board.</li>
        </ul>
      </Card>

      <Card>
        <h2 className="font-chunky text-base mb-2">Built by</h2>
        <p className="text-sm text-text-dim leading-relaxed">
          James Cox.{' '}
          <a className="text-trophy-gold" href="mailto:hello@punditxi.app">
            hello@punditxi.app
          </a>
          .
        </p>
      </Card>

      <Card>
        <h2 className="font-chunky text-base mb-2">Links</h2>
        <ul className="space-y-1 text-sm">
          <li>
            <a className="text-trophy-gold" href="/privacy">
              Privacy policy →
            </a>
          </li>
          <li>
            <a className="text-trophy-gold" href="/terms">
              Terms of service →
            </a>
          </li>
        </ul>
      </Card>

      <div className="font-mono text-[10px] text-text-faint text-center">
        PunditXI · v1.0
      </div>
    </div>
  );
}
